export default "__VITE_ASSET__BMNYCIIk__"